var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87888 15.5H3.14041L13.377 5.2634L12.1155 4.00188L1.87888 14.2385V15.5ZM0.378906 17V13.6154L13.5693 0.430775C13.7205 0.293425 13.8875 0.187292 14.0702 0.112375C14.2529 0.0374582 14.4445 0 14.645 0C14.8455 0 15.0397 0.0355838 15.2277 0.10675C15.4157 0.177901 15.5821 0.291034 15.7269 0.44615L16.9481 1.68268C17.1032 1.82754 17.2138 1.99424 17.2798 2.18278C17.3458 2.37129 17.3789 2.55981 17.3789 2.74833C17.3789 2.94941 17.3445 3.14131 17.2758 3.32403C17.2072 3.50676 17.0979 3.67373 16.9481 3.82495L3.76348 17H0.378906ZM12.7352 4.6437L12.1155 4.00188L13.377 5.2634L12.7352 4.6437Z",
    fill: "#505D69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a859e01d0d59c9dd482fabdb9a28a85f.svg";
export { ForwardRef as ReactComponent };